import type { Action, ActionReducerMap } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';

import type { SelectedSupplyAddressState } from './select-supply-address.reducer';
import { selectedSupplyAddressReducer } from './select-supply-address.reducer';

export interface SupplyAddressState {
  readonly selectedSupplyAddress: SelectedSupplyAddressState;
}

export const supplyAddressReducers: ActionReducerMap<
  SupplyAddressState,
  Action
> = {
  selectedSupplyAddress: selectedSupplyAddressReducer,
};

export const supplyAddressSelectorKey = 'supplyAddress';

export const getSupplyAddressState = createFeatureSelector<SupplyAddressState>(
  supplyAddressSelectorKey
);
